import { AndroidNotify } from "./AndroidNotify";
import { DownloadQrCard } from "./DownloadQrCard";

// Live store URLs.
export const STORE_LINKS = {
    appStore: "https://apps.apple.com/gb/app/meet-lunar/id6802579376",
    googlePlay: "https://play.google.com/store/apps/details?id=com.meetwitholive.app&pcampaignid=web_share",
};

const AppleIcon = () => (
    <svg viewBox="0 0 384 512" className="h-6 w-6 shrink-0" fill="currentColor" aria-hidden="true">
        <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
);

const PlayIcon = () => (
    <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" fill="currentColor" aria-hidden="true">
        <path d="M4.5 2.6v18.8c0 .8.9 1.3 1.6.9l14.9-9.4c.6-.4.6-1.3 0-1.7L6.1 1.7c-.7-.4-1.6.1-1.6.9z" />
    </svg>
);

const btnBase =
    "group box-border inline-flex h-[72px] items-center gap-3 rounded-2xl bg-[#1D201A] px-5 py-3 text-[#F9F8F4] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4A5D23]";
const btn = `${btnBase} transition-[background-color,transform] duration-300 ease-out hover:bg-[#2C3618] hover:-translate-y-[2px]`;

export const StoreButtons = ({ appStoreTestId, googlePlayTestId, centered = false, showQr = true }) => {
    const qrTestId = appStoreTestId ? `${appStoreTestId}-qr` : "store-download-qr";
    const notifyTestId = googlePlayTestId ? `${googlePlayTestId}-notify` : "google-play-notify";
    const googlePlayLive = /^https?:\/\//.test(STORE_LINKS.googlePlay);

    return (
        <div className={`flex flex-col gap-3 sm:flex-row sm:items-center ${centered ? "justify-center" : ""}`}>
            <a href={STORE_LINKS.appStore} data-testid={appStoreTestId} className={btn} aria-label="Download on the App Store">
                <AppleIcon />
                <span className="text-left leading-tight">
                    <span className="block text-[10px] font-medium uppercase tracking-[0.14em] text-[#C2C0B8]">
                        Download on the
                    </span>
                    <span className="block text-lg font-bold">App Store</span>
                </span>
            </a>
            <div className="flex flex-col">
                {googlePlayLive ? (
                    <a href={STORE_LINKS.googlePlay} data-testid={googlePlayTestId} className={btn} aria-label="Get it on Google Play">
                        <PlayIcon />
                        <span className="text-left leading-tight">
                            <span className="block text-[10px] font-medium uppercase tracking-[0.14em] text-[#C2C0B8]">
                                Get it on
                            </span>
                            <span className="block text-lg font-bold">Google Play</span>
                        </span>
                    </a>
                ) : (
                    <>
                        <div
                            data-testid={googlePlayTestId}
                            className={`${btnBase} cursor-not-allowed opacity-85`}
                            role="img"
                            aria-label="Google Play app coming soon"
                        >
                            <PlayIcon />
                            <span className="text-left leading-tight">
                                <span className="block text-[10px] font-medium uppercase tracking-[0.14em] text-[#C2C0B8]">
                                    Get it on
                                </span>
                                <span className="block text-lg font-bold">Google Play</span>
                            </span>
                        </div>
                        <AndroidNotify testId={notifyTestId} />
                    </>
                )}
            </div>
            {showQr && <DownloadQrCard testId={qrTestId} />}
        </div>
    );
};
